import React, { Component } from 'react';
import Swiper from 'swiper';
import SwiperItem from './item';
import 'swiper/css/swiper.min.css' // 引入样式
import styles from './index.module.scss?v=20220629'

class Slider extends Component {
  componentDidMount(){
     setTimeout(function(){
        new Swiper('.swiper-container', {
            loop: true,
            autoplay: true,
            pagination: {
                el: '.swiper-pagination',
                clickable :true,
            },
            // navigation: {
            //     nextEl: '.swiper-button-next', // 右按钮
            //     prevEl: '.swiper-button-prev', // 左按钮
            // }
        });
     },500)
  }
  render(){
    return (
        <div className={`swiper-container ${styles.swiper}`}>
            <div className="swiper-wrapper">
                <SwiperItem list={this.props.list}></SwiperItem>
            </div>
            <div className="swiper-pagination"></div>
            {/* <div className="swiper-button-next"></div>
            <div className="swiper-button-prev"></div> */}
        </div>
        )
    }
}


class App extends Component {
  render(){
    return <div>
        <Slider></Slider>
    </div>
  }
}



export default App;